module.exports = __webpack_public_path__ + "img/Office_Group_Laptop_Foreground_Dynamic_Labels_Home_Screen.f575dbae.jpg";